export const init = () => {
    const currentLocationEls = $('.current-location');
    if (currentLocationEls.length) {
        $.ajax({
            dataType: 'json',
            url: `/wp/wp-admin/admin-ajax.php?action=getGeoData`,
            success: (res) => {
                const isMobile = res.MM_CONNECTION_TYPE === 'Cellular';

                if (!isMobile && res.MM_CITY_NAME && res.MM_FULL_STATE) {
                    currentLocationEls.each(function (_, element) {
                        const value = `in ${res.MM_CITY_NAME}, ${res.MM_FULL_STATE}`;
                        $(element).text(value);
                    });
                }
            },
            error: () => {
                console.log('MAPI lookup error');
            },
        });
    }
};
